import styled from '@emotion/styled'
import { GridRight, GridLeft } from '~/utils/styles'
import Heading from '../../components/Heading'
import { breakpoints } from '../../utils/styles'

export const Right = styled(GridRight)`
  display: flex;
  justify-content: center;
`

export const Left = styled(GridLeft)`
  display: flex;
  height: 100%;
  justify-content: center;
`

export const Container = styled.div`
  // background: red;

  display: flex;
  justify-content: center;
  align-items: center;
`

export const Product = styled.div`
  // background: blue;
  display: flex;
  width: 100%;
  max-width: 600px;
  align-items: center;

  table {
    font-size: 14px;
    width: 100%;
    margin-top: 20px;
  }

  thead {
    background: #dcd0af;
  }

  tr td {
    text-align: center;
  }

  tr td:first-child {
    text-align: left;
  }

  @media (max-width: ${breakpoints.s}px) {
    padding: 20px;
  }
`

export const Image = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
`

export const ProductTitle = styled(Heading)`
  font-size: 48px;
  line-height: 1.2;

  @media (max-width: ${breakpoints.s}px) {
    font-size: 30px;
  }
`

export const Label = styled.p`
  font-family: 'SohneBreit';
  font-weight: 400;
  letter-spacing: 1px;
  font-size: 28px;
`

export const Upsell = styled.p`
  background: #d16643;
  padding: 20px;
  border-radius: 20px;
  max-width: 400px;
  box-sizing: border-box;
  color: white;
`
